<div class="bulk-search" [resBusySpinner]="isBulkSearchBusy" [message]="bulkSearchBusyMessage"
    [attr.data-automation-id]="automationId + '-container'">
    <div class="top-container" [ngClass]="{'slide-up': workflowMode}" [hidden]="isDisabled">
        <div class="metadata-group">
            <res-custom-checkbox [automationId]="automationId + '-by-metadata-field'" [(ngModel)]="isMetadataSearch"
                (ngModelChange)="onIsMetadataChanged()" content="By Metadata Field:"
                [hidden]="isExportSettings || workflowMode">
            </res-custom-checkbox>
            <select [(ngModel)]="selectedMetadataField" [attr.data-automation-id]="automationId + '-metadata-option'"
                [disabled]="!isMetadataSearch" [hidden]="isExportSettings || workflowMode"
                (ngModelChange)="onSelectedMetadataFieldChanged()" (mousedown)="$event.stopPropagation()">
                <option *ngFor="let metadata of metadataFields; index as i; trackBy:identify" [ngValue]="metadata">
                    {{metadata.displayName}}</option>
            </select>
            <button type="button" [hidden]="!isExportSettings || workflowMode"
                class="secondary-button validate-bulk-queries" [ngClass]="[isExportSettings ? 'no-left-margin' : '']"
                (click)="validateBulkQueries()" [attr.data-automation-id]="automationId + '-validate-button'"
                [disabled]="!isValidateEnabled()">
                <i class="fa fa-check"></i>
                <span>Validate</span>
            </button>
            <div class="validation-popovers">
                <div [(resScrollablePopover)]="showPopover" [popoverErrorMessage]="popoverMessage"
                    [popoverType]="popoverType" popoverPlacement="top" [popoverOffsetTop]="40" [isSingleLine]="true"
                    [popoverAutomationId]="automationId  + '-validation-label'" [showUpDownArrows]="showUpDownArrows()"
                    (showPrevious)="showPreviousError()" (showNext)="showNextError()"></div>
            </div>
        </div>
        <div class="button-group">
            <input #openBulkFileInput type="file" (change)="localFileUpload($event)" onclick="this.value=null;"
                [attr.data-automation-id]="automationId + '-input-file'" />
            <li class="dropdown" dropdown [hidden]="isExportSettings || workflowMode">
                <button dropdownToggle type="button" class="secondary-button"
                    [attr.data-automation-id]="automationId + '-load-from-file-button'">
                    <i class="fa fa-plus"></i>
                    <span>Load from</span>
                    <i class="fa fa-caret-down"></i>
                </button>
                <ul *dropdownMenu class="dropdown-menu">
                    <li (click)="openBulkFileInput.click()" class="menu-item"
                        [attr.data-automation-id]="automationId + '-local-file-button'">
                        <label for="openBulkFileInput">
                            <i class="fa fa-folder-open menu-item-icon color-tan-07"></i>Local file...
                        </label>
                    </li>
                    <li (click)="connectorFileClicked()" class="menu-item" *ngIf="hasConnectorAccessPermissions"
                        [attr.data-automation-id]="automationId + '-connector-file-button'">
                        <label>
                            <i class="fa fa-cloud menu-item-icon color-blue-01"></i>Connector file...
                        </label>
                    </li>
                </ul>
            </li>
            <button type="button" [attr.data-automation-id]="automationId + '-load-from-file-button'"
                class="secondary-button" [hidden]="!isExportSettings && !workflowMode"
                (click)="openBulkFileInput.click()">
                <i class="fa fa-folder-open color-tan-07"></i>
                <span>Load from Local File ...</span>
            </button>
            <button type="button" [attr.data-automation-id]="automationId + '-clear-all-button'"
                class="secondary-button order-last" (click)="clearAllQueries()">
                <i class="fa fa-trash"></i>
                <span>Clear All</span>
            </button>
        </div>
    </div>
    <div class="query-container"
        [ngClass]="[isExportSettings ? 'query-container-export-settings' : '', isDisabled ? 'query-container-disabled' : '', workflowMode && customizeClass ? 'query-container-customization' : '']">
        <res-key-value-list [hidden]="hasConnectorPath || hasFileLargerThanLimit" [isDisabled]="isDisabled"
            [pasteSplitOnNewLineOnly]="true" [placeholderField1]='"Enter or paste up to 5k terms/queries here ... "'
            [rows]="queries" [queryColumnHidden]="true" [automationId]="automationId + '-'" [showClearNameBtn]="true"
            [queriesChanged]="queriesChanged.bind(this)" [validateName]="false" [trackDirty]="false"
            [maxRows]="bulkQueryLimit" [cdkScrollMinBufferPx]="workflowMode ? 1500 : 300"
            [cdkScrollMaxBufferPx]="workflowMode ? 3000 : 600" [maxRowsLimitReached]="maxRowsLimitReached.bind(this)"
            [showNumberColumn]="true" [customizeClass]="customizeClass && isExportSettings"
            [isNameValidationContext]="true">
        </res-key-value-list>
        <span [hidden]="!hasConnectorPath" class="path">{{ selectedConnectorPath }}</span>
        <span [hidden]="!hasFileLargerThanLimit" [ngClass]="!workflowMode ? 'path' : ''"
            [attr.data-automation-id]="automationId + '-local-file-name'">{{selectedFileNameLargerThanLimit}}</span>
    </div>
    <div class="options-container" *ngIf="!isExportSettings">
        <div class="combine-group" [hidden]="isExportSettings">
            <res-custom-checkbox [automationId]="automationId + '-run-as-combined-search-using'" [hidden]="workflowMode"
                [(ngModel)]="runAsCombinedSearch" (ngModelChange)="onRunAsCombinedChanged()"
                [disabled]="isMetadataSearch" content="Run as Combined Search using:"></res-custom-checkbox>
            <span [hidden]="!workflowMode">Run as Combined Search using:</span>
            <select [(ngModel)]="selectedCombineOperator"
                [attr.data-automation-id]="automationId + '-combine-operator-option'"
                [disabled]="!runAsCombinedSearch || isMetadataSearch">
                <option value='OR'>OR</option>
                <option value='AND'>AND</option>
            </select>
        </div>
        <res-collapsible-toggle-box-group [toggleItems]="searchOptions" [activated]="isBulkVisible"
            [automationId]="automationId + '-options'" [hidden]="isExportSettings"></res-collapsible-toggle-box-group>
    </div>
</div>